import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { KpiCard } from '../../components/KpiCard';
import { useLearningStats } from './useLearningStats';

/**
 * Produkt-Statistik Lernplattform — Betreiber-Sicht, nur lesend. KPI-Kacheln
 * über Kurse, Einschreibungen, Abschlüsse, Lernende, Zertifikate und Sessions
 * plus die berechnete Abschlussquote. Keine Aufschlüsselung (alles Skalare).
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusLearningStatsPage() {
  const stats = useLearningStats();
  const data = stats.data ?? {};
  const completionRate = data.enrollments
    ? `${((data.completed / data.enrollments) * 100).toFixed(1)} %`
    : '—';

  return (
    <div>
      <PageHeader title="Lernplattform" subtitle="Produkt-Statistik — Kurse, Einschreibungen, Abschlüsse" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="2"><KpiCard label="Kurse" value={fmt.format(data.courses ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Einschreibungen" value={fmt.format(data.enrollments ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Abschlüsse" value={fmt.format(data.completed ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Lernende" value={fmt.format(data.learners ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Zertifikate" value={fmt.format(data.certificates ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Sessions" value={fmt.format(data.sessions ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Abschlussquote" value={completionRate} /></Col>
      </Row>
    </div>
  );
}
